import { createAction } from 'redux-actions';

export const SetLoading = createAction('SET_LOADING');
